<template>
  <div v-if="loading" class="loading-api">
    <LoaderCircle class="spinner" :size="48" :stroke-width="2.5" />
  </div>
</template>

<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next';
import { useLoadingStore } from '@centric-os/stores/loading/use-loading-store';
import { storeToRefs } from 'pinia';

const loadingStore = useLoadingStore();
const { loading } = storeToRefs(loadingStore);
</script>

<script lang="ts">
export default {
  name: 'LoadingApi',
};
</script>

<style scoped lang="scss">
.loading-api {
  position: fixed;
  right: 6rem;
  bottom: 6rem;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-navy-800);

  .spinner {
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
